import styled from 'styled-components';

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;

export const BtnContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;
